import Model, { valueWithArray } from 'ducker-model';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';

const property = {
  mediaInfo: Object, // 音视频
  wealthInfo: Object, // 财富号信息
  readInfo: valueWithArray(Object), // 资讯解读
  bottomWealthInfo: Object, // 财富号底部信息
  fundAnnouncement: valueWithArray(Object), // 公告
  newFundRead: valueWithArray(Object), // 新发基金解读
};

const replacedKeyFromPropertyName = {
  mediaInfo: { // 音视频
    property: ['fundannouncement', 'fundread', 'fundreport'],
    computed: ([announcement, read, report]) => {
      const temp = [...(announcement || []), ...(read || []), ...(report || [])];
      const index = temp.findIndex((item) => item?.media?.type === 1);
      return index > -1 ? temp[index].media : {};
    },
  },
  wealthInfo: { // 财富号信息
    property: 'cfhinfos[0]',
    computed: (cfhInfo) => {
      const labelinfos = cfhInfo?.labelinfos;
      const labelName = labelinfos && labelinfos.length ? labelinfos[0].title : '';
      const cfhname = cfhInfo?.cfhname;
      const link = cfhInfo?.link;
      return {
        wealthName: isEmpty(cfhname) ? '' : cfhname,
        labelName,
        wealthLink: link,
      };
    },
  },
  readInfo: { // 资讯解读
    property: ['fundread'],
    computed: ([data]) => {
      if (data?.length) {
        const result = [];
        data.forEach((item) => {
          if (item?.readtype?.type === 13) return;
          result.push({
            type: 'read',
            content: item?.readtitle,
            tag: item?.readtype?.name,
            tagColor: '#3A90FA',
            link: item?.link,
            date: item?.updatetimestr,
          });
        });
        return result;
      }
      return [];
    },
  },
  bottomWealthInfo: { // 财富号底部信息
    property: ['cfhinfos[0]', 'fixedbottomguilder[0]'],
    computed: ([cfhInfo, fixedbottomguilder]) => ({
      image: cfhInfo?.headerimgpath || 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322861.png',
      url: cfhInfo?.link?.linkTo || '',
      linkType: cfhInfo?.link?.linkType || '',
      name: cfhInfo?.cfhname,
      tipText: fixedbottomguilder?.palacedescription,
      guideText: fixedbottomguilder?.bottomdescription,
    }),
  },
  fundAnnouncement: { // 公告
    property: 'fundannouncement',
    computed: (data) => {
      if (isEmpty(data)) {
        return [];
      }
      const result = [];
      data.forEach((item) => {
        result.push({
          content: item?.readtitle,
          url: item?.link?.linkTo,
          linkType: item?.link?.linkType,
          hotKey: [],
        });
      });
      return result;
    },
  },
  newFundRead: { // 新发基金解读
    property: 'fundread',
    computed: (data) => {
      const index = data?.findIndex((item) => item?.readtype?.type === 13);
      if (index > -1) {
        const item = data[index];
        return [{
          title: item?.readtitle || '',
          content: item?.readdecription || '',
          url: item?.link?.linkTo || '',
          linkType: item?.link?.linkType || '',
        }];
      }
      return [];
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
